import { Card } from "@postenbring/hedwig-react";
import { BodyLink, LINKTYPE_EXTERNAL, LINKTYPE_INTERNAL } from "./subcomponents/BodyLink";
import { CTAButtonGroup, LINKTYPE_CTA } from "./subcomponents/CTAButtonGroup";
import { ImageIllustration } from "./subcomponents/ImageIllustration";

import "./kp-cards.scss";

export const FocusCard = ({
    imageUrl,
    imageAltText,
    imagePosition,
    focalPointStyle,
    isIllustration,
    isAnimatedGif,
    pauseImageUrl,
    pauseAnimationLabel,
    playAnimationLabel,
    header,
    title,
    description,
    backgroundColor,
    linkOrButtons,
    theme,
}) => {
    const firstLinkOrCtaType = linkOrButtons?.[0]?.type;

    return (
        <Card
            variant="focus"
            color={backgroundColor}
            imagePosition={imagePosition}
            data-color-scheme="dark"
            theme={theme}
        >
            {imageUrl && (
                <ImageIllustration
                    imageUrl={imageUrl}
                    imageAltText={imageAltText}
                    isIllustration={isIllustration}
                    focalPointStyle={focalPointStyle}
                    isAnimatedGif={isAnimatedGif}
                    pauseImageUrl={pauseImageUrl}
                    pauseAnimationLabel={pauseAnimationLabel}
                    playAnimationLabel={playAnimationLabel}
                />
            )}

            <Card.Body>
                {(header || title) && (
                    <Card.BodyHeader as="h2">
                        {header && <Card.BodyHeaderOverline>{header}</Card.BodyHeaderOverline>}
                        {title && <Card.BodyHeaderTitle>{title}</Card.BodyHeaderTitle>}
                    </Card.BodyHeader>
                )}
                {description && <Card.BodyDescription>{description}</Card.BodyDescription>}
                {firstLinkOrCtaType === LINKTYPE_INTERNAL ||
                firstLinkOrCtaType === LINKTYPE_EXTERNAL ? (
                    <BodyLink {...linkOrButtons[0]} inverted />
                ) : firstLinkOrCtaType === LINKTYPE_CTA ? (
                    <CTAButtonGroup buttons={linkOrButtons} inverted />
                ) : null}
            </Card.Body>
        </Card>
    );
};
